import { render, staticRenderFns } from "./ClinicalTriage.vue?vue&type=template&id=25b90f95&scoped=true&"
import script from "./ClinicalTriage.vue?vue&type=script&lang=js&"
export * from "./ClinicalTriage.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalTriage.vue?vue&type=style&index=0&id=25b90f95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b90f95",
  null
  
)

export default component.exports